import { __decorate } from "tslib";
import { designToken, provideTokens, swatchConverter } from '@genesislcap/foundation-ui';
import { DesignSystemProvider as FASTDesignSystemProvider, neutralFillStealthRest, neutralForegroundRest, } from '@microsoft/fast-components';
import { attr, html } from '@microsoft/fast-element';
import * as tokens from '../_config/tokens';
import * as values from '../_config/values';
import { designSystemProviderStyles } from './design-system-provider.styles';
/**
 * The Zero Design System Provider
 * @public
 * @tagname %%prefix%%-design-system-provider
 */
export class ZeroDesignSystemProvider extends FASTDesignSystemProvider {
    constructor() {
        super();
        provideTokens(tokens, values, this);
    }
}
__decorate([
    attr({
        attribute: 'card-fill-color',
        converter: swatchConverter,
    }),
    designToken(neutralFillStealthRest)
], ZeroDesignSystemProvider.prototype, "cardFillColor", void 0);
__decorate([
    attr({
        attribute: 'card-foreground-color',
        converter: swatchConverter,
    }),
    designToken(neutralForegroundRest)
], ZeroDesignSystemProvider.prototype, "cardForegroundColor", void 0);
/**
 * The Zero Design System Provider composed element
 *
 * @public
 * @remarks
 * HTML Element: \<zero-design-system-provider\>
 */
export const zeroDesignSystemProvider = ZeroDesignSystemProvider.compose({
    baseName: 'design-system-provider',
    template: html `
    <slot></slot>
  `,
    styles: designSystemProviderStyles,
});
